import { IconCreditCard, IconLogout, IconSettings, IconStairs, IconSticker2, IconUser } from '@tabler/icons-react';
import { routes } from '~/shared/constants/routes';
import { type Mode } from '~/shared/store/mode';
import { type NavbarTab } from './components';

export const payinTabs: NavbarTab[] = [
    {
        icon: IconCreditCard,
        label: 'Ордера',
        to: routes.app,
        isActive: (pathname) => {
            return pathname.startsWith(routes.payin) || pathname.startsWith(routes.payout);
        },
    },
    {
        icon: IconSticker2,
        label: 'Уведомления',
        to: routes.tickets,
        isActive: (pathname) => {
            return pathname.startsWith(routes.tickets);
        },
    },
    {
        icon: IconUser,
        label: 'Трейдеры',
        to: routes.traders,
        isActive: (pathname) => {
            return pathname.startsWith(routes.traders);
        },
    },
    {
        icon: IconSettings,
        label: 'Настройки',
        to: routes.settings,
        isActive: (pathname) => {
            return pathname.startsWith(routes.settings);
        },
    },
];

export const payoutTabs: NavbarTab[] = [
    {
        icon: IconCreditCard,
        label: 'Ордера',
        to: routes.app,
        isActive: (pathname) => {
            return pathname.startsWith(routes.payin) || pathname.startsWith(routes.payout);
        },
    },
    {
        icon: IconSticker2,
        label: 'Уведомления',
        to: routes.tickets,
        isActive: (pathname) => {
            return pathname.startsWith(routes.tickets);
        },
    },
    {
        icon: IconUser,
        label: 'Трейдеры',
        to: routes.traders,
        isActive: (pathname) => {
            return pathname.startsWith(routes.traders);
        },
    },
    {
        icon: IconStairs,
        label: 'Каскады',
        to: routes.cascades,
        isActive: (pathname) => {
            return pathname.startsWith(routes.cascades);
        },
    },
    {
        icon: IconSettings,
        label: 'Настройки',
        to: routes.settings,
        isActive: (pathname) => {
            return pathname.startsWith(routes.settings);
        },
    },
];

export const logoutTab = (onLogout?: VoidFunction): NavbarTab => {
    return {
        icon: IconLogout,
        label: 'Выйти',
        onClick: onLogout,
    };
};

export const tabs: Record<Mode, NavbarTab[]> = {
    payin: payinTabs,
    payout: payoutTabs,
} as const;

export const mobileTabs: Record<Mode, NavbarTab[]> = {
    payin: payinTabs.slice(1),
    payout: payoutTabs.slice(1),
};
